import React from "react";
import Spinner from "@/components/common/Spinner";

const Loading = () => {
  return (
    <div
      style={{
        position: "relative",
        width: "100%",
        height: "100vh",
        background: "#ffffffb7",
        zIndex: 99999,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <div
        style={{
          font: "1rem Noto Sans KR",
          textAlign: "center",
        }}
      >
        잠시만 기다려 주세요.
      </div>
      <Spinner size={80} />
    </div>
  );
};

export default Loading;
